import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';
import { LAYOUT_CONFIG_VERSION, LAYOUT_VERSION, loadLayoutStyles } from './app/layout-version';

// Invalidate any stale coreConfig saved in localStorage from previous layouts
// (LAYOUT_VERSION elige el layout: 1 = master, 2 = nuevo).
if (localStorage.getItem('coreConfigVersion') !== LAYOUT_CONFIG_VERSION) {
  localStorage.removeItem('config');
  localStorage.setItem('coreConfigVersion', LAYOUT_CONFIG_VERSION);
}

if (environment.production) {
  enableProdMode();
}

// La hoja global de la versión (layout-v1/layout-v2) se carga antes de
// arrancar, para que la app no se pinte sin estilos
const bootstrap = () => loadLayoutStyles().then(() => {
  // La hoja trae su versión: si no coincide, layout y colores quedan mezclados
  const cssLayoutVersion = getComputedStyle(document.documentElement).getPropertyValue('--layout-version').trim();
  if (cssLayoutVersion && cssLayoutVersion !== String(LAYOUT_VERSION)) {
    console.error(`El layout es la versión ${LAYOUT_VERSION} pero los estilos son de la ${cssLayoutVersion}: revisar los bundles layout-v1/layout-v2 en angular.json`);
  }

  return platformBrowserDynamic().bootstrapModule(AppModule);
});

if (environment.hmr) {
  if (module['hot']) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap().catch(err => console.log(err));
}
